import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

const languages = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
];

export const LanguageSwitcher = ({ variant = 'icon' }) => {
  const { i18n } = useTranslation();

  const switchLanguage = (code) => {
    const lang = languages.find(l => l.code === code);
    i18n.changeLanguage(code);
    localStorage.setItem('inspirotracker-lang', code);
    document.documentElement.dir = lang?.dir || 'ltr';
    document.documentElement.lang = code;
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 w-9 p-0 rounded-xl hover:bg-slate-100 dark:bg-slate-700 dark:hover:bg-slate-800"
          data-testid="language-switcher-btn"
        >
          <Globe className="w-4 h-4 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl min-w-[140px]">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => switchLanguage(lang.code)}
            className={cn(
              "cursor-pointer rounded-lg text-sm",
              i18n.language === lang.code && "bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:bg-blue-900/10 dark:text-blue-400"
            )}
            data-testid={`lang-switch-${lang.code}`}
          >
            <span className="flex-1">{lang.label}</span>
            {i18n.language === lang.code && (
              <span className="text-blue-500 text-xs font-bold">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
